var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.3125 6.52172C0.3125 3.09246 3.09246 0.3125 6.52172 0.3125C9.95098 0.3125 12.7309 3.09246 12.7309 6.52172C12.7309 7.97054 12.2348 9.30286 11.4039 10.359L15.4713 14.4264C15.5399 14.495 15.5944 14.5765 15.6315 14.6662C15.6687 14.7559 15.6878 14.852 15.6878 14.9491C15.6878 15.0462 15.6687 15.1423 15.6315 15.232C15.5944 15.3217 15.5399 15.4032 15.4713 15.4719C15.4026 15.5405 15.3211 15.595 15.2314 15.6321C15.1417 15.6693 15.0456 15.6884 14.9485 15.6884C14.8514 15.6884 14.7553 15.6693 14.6656 15.6321C14.5759 15.595 14.4944 15.5405 14.4258 15.4719L10.3584 11.4039C9.26535 12.2655 7.91353 12.7331 6.52172 12.7309C3.09246 12.7309 0.3125 9.95098 0.3125 6.52172ZM6.52172 1.79089C5.26703 1.79089 4.06372 2.28931 3.17652 3.17652C2.28931 4.06372 1.79089 5.26703 1.79089 6.52172C1.79089 7.77642 2.28931 8.97972 3.17652 9.86693C4.06372 10.7541 5.26702 11.2526 6.52172 11.2526C7.77642 11.2526 8.97972 10.7541 9.86693 9.86693C10.7541 8.97972 11.2526 7.77642 11.2526 6.52172C11.2526 5.26703 10.7541 4.06372 9.86693 3.17652C8.97972 2.28931 7.77642 1.79089 6.52172 1.79089Z",
    fill: "#0D8ECA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ef45fe129ac12d53aa49846df9c2e22e.svg";
export { ForwardRef as ReactComponent };